import React from "react";
import { connect } from "react-redux";
import DynamicForm from "../../../components/dynamicscreens/DynamicForm";
import { outletTypeJson } from "../../../DynamicFormsJson/MastersJSON/outletType";
import { getSubChannel } from "../../../Slice/channel.slice";
import { showLoador, showNotification } from "../../Landing/Landing.slice"
class OutletTypeForm extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            dynamicMasterData: {
                subChannelDetail: this.props.subChannelList?.subChannel,
            },
        };
    }

    async componentDidMount() {
        const { getSubChannel, showLoador, showNotification } = this.props;
        if (navigator.onLine) {

            if (localStorage.getItem("subChannelWiseOutletType") && localStorage.getItem("subChannelWiseOutletType") == 1) {
                showLoador({ loador: true });
                await getSubChannel().then(({ success }) => {
                    showLoador({ loador: false });
                    if (!success) {
                        showNotification({ msg: serverMsg, severity: "error" });
                    }
                });
            }

        } else {
            this.props.showNotification({ msg: noInternetMsg, severity: "error" });
        }
    }

    componentWillReceiveProps(nextProps) {
        if (this.props.subChannelList !== nextProps.subChannelList) {
            if (this.props.subChannelList?.subChannel !== nextProps.subChannelList?.subChannel) {
                this.setState({
                    dynamicMasterData: {
                        ...this.state.dynamicMasterData,
                        subChannelDetail: nextProps.subChannelList?.subChannel,
                    },
                });
            }
        }
    }

    render() {
        const { dynamicMasterData } = this.state;
        return (
            <>
                <DynamicForm
                    dynamicMasterData={dynamicMasterData}
                    formPath={outletTypeJson.formPath}
                    screenTitle={outletTypeJson.screenTitle}
                    fieldMeta={
                        localStorage.getItem("subChannelWiseOutletType") &&
                            localStorage.getItem("subChannelWiseOutletType") == 1 ?
                            outletTypeJson.fieldMetaForSubChannelWise : outletTypeJson.fieldMeta
                    }
                    apiBaseURL={outletTypeJson.apiBaseURL}
                />
            </>
        );
    }
}
const mapStateToProps = (state) => ({
    subChannelList: state.channel
});
const mapDispatchToProps = {
    getSubChannel,
    showLoador,
    showNotification,
};
export default connect(mapStateToProps, mapDispatchToProps)(OutletTypeForm);
